import React from "react";
import PropTypes from "prop-types";
import Identicon from "identicon.js";
import DappsStore from "../../stores/DappsStore";

const options = {
    //  foreground: [255, 255, 255, 255],               // rgba black
    background: [255, 152, 0, 0], // rgba white
    margin: 0.2, // 20% margin
    size: 420, // 420px square
    format: 'svg' // use SVG instead of PNG
};

const defaultHash = 'cfcd208495d565ef66e7dff9f98764da';

function DappIcon({...props}) {
    const {dapp, size, style, hash} = props;
    const defaultStyle = {
        minHeight: size + 'px',
        height: size + 'px',
        borderRadius: '50%',
        minWidth: size + 'px',
        width: size + 'px',
        objectFit: 'cover',
        objectPosition: 'center',
    }
    if( dapp ){
        if (dapp.image) {
            return <img src={ dapp.image } style={ Object.assign(defaultStyle, style)} alt={ dapp.title } />
        } else {
            return <img width={size} height={size} style={ style } src={'data:image/svg+xml;base64,' + DappsStore.getIconById(dapp.id)} alt={ dapp.title } />
        }
    } else {
        if( hash ){
            let icon = new Identicon(hash, options).toString();
            return <img width={size} height={size} style={ style } src={'data:image/svg+xml;base64,' + icon} alt={ hash } />
        } else {
            let icon = new Identicon(defaultHash, options).toString();
            return <img width={size} height={size} style={ style } src={'data:image/svg+xml;base64,' + icon} alt={ defaultHash } />
        }
    }
}

DappIcon.propTypes = {
    dapp: PropTypes.object,
    hash: PropTypes.string,
    size: PropTypes.number,
    style: PropTypes.object,
};

export default DappIcon;



// WEBPACK FOOTER //
// ./src/components/Dapp/DappIcon.jsx